export default function postMessageToReactNative(message: unknown) {
  try {
    const postMessage =
      window.webkit?.messageHandlers?.ReactNativeWebView ?? window.ReactNativeWebView
    if (postMessage) {
      postMessage.postMessage(JSON.stringify(message))
    }
  } catch (error) {
    console.error('Error posting message to React Native', error)
  }
}
